import { createSlice } from "@reduxjs/toolkit";
import { FULLFILLED, PAGINATION_DEFAULTS } from "@root/constants";
import { GET_THREADS } from "@root/store/action-types";

const initialValue: IChatFeature = {
  data: {
    page: 1,
    pageSize: PAGINATION_DEFAULTS.PAGESIZE,
    pageCount: 0,
  },
  isFilterApplied: false,
  listThreads: [],
};

export const chatFeatureSlice = createSlice({
  name: "chat",
  initialState: initialValue,
  reducers: {
    updatePage: (state, action: any) => {
      state.data.page = action.payload;
    },
    updateToogleFilter: (state, action: any) => {
      state.isFilterApplied = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(`${GET_THREADS}${FULLFILLED}`, (state, action: any) => {
      state.data.pageCount = action?.payload?.count;
      state.listThreads = state?.isFilterApplied
        ? state.listThreads
        : action?.payload?.rows;
    });
  },
});

export const chatFeatureReducer = chatFeatureSlice.reducer;
export const { updatePage, updateToogleFilter } = chatFeatureSlice.actions;
